import { ooFetchWithResponse } from './ooFetchWithResponse';

let uploadApi = {
    uploadSchwab: async(data) => {
        let formData = new FormData();

        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });

        let url = 'uploads/v1';
        let response = await ooFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    }
}

export { uploadApi };